// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"91e87d40","337":"25ecb1a2","453":"3792d2b6","667":"df7ff34a"}[chunkId] + ".chunk.js";
};